export enum SSO_SYSTEMS {
    IMLK_MANEGER = 2,
    IMLK_VIEWER = 3,
    WORKFLOW_ADMIN = 4,
    WORKFLOW_END_USER = 5,
    DEWAN_ADMIN = 6,
    DEWAN_END_USER = 7
}

export enum OPTIONS {
    COUNTOFLOCK = 1,
    URL = 2
}